import { ReactElement, useEffect, useState } from 'react';
import useCurrentUser from 'hooks/useCurrentUser';
import { FeatureFlag } from 'config';
import Recipe from './Recipe';
import cartProduct from '../../../models/CartProduct';
import cartItem from '../../../models/CartItem';
import ProductPackage from './ProductPackage';
import { useCart } from '../../../contexts/Cart';

type Props = {
  productsByMealType: cartProduct[];
  hasFavoritesEnabled: boolean;
  lastAddedItem: cartItem;
  mealTypeIndex: number;
}

const ResponsiveIndex = (index: number, width: number): number => {
  if (width < 600) {
    return index;
  } if (width < 1025) {
    if (index % 2 === 0) {
      return index + 1;
    }
  }

  return index + ((2 - (index % 3)) % 3);
};

function MealTypeRecipes({
  productsByMealType,
  hasFavoritesEnabled,
  lastAddedItem,
  mealTypeIndex,
}: Props): ReactElement {
  const { currentUser } = useCurrentUser();
  const hasCpppEnabled = currentUser.hasFeatureEnabled(
    FeatureFlag.CPPP_DISPLAYED,
  );
  const { menu } = useCart().cart;
  const productIds = productsByMealType.map((item) => item.productId);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const itemIndex = lastAddedItem ? productIds.indexOf(lastAddedItem.sku.product_id) : -1;
  if (itemIndex !== -1) {
    const newIndex = ResponsiveIndex(itemIndex, width);
    const itemsBeforeIndex = productsByMealType.slice(0, newIndex + 1);
    const itemsAfterIndex = productsByMealType.slice(newIndex + 1);
    return (
      <>
        <div className="c-form-group c-recipe-gallery">
          <div className="row">
            {itemsBeforeIndex.map((product) => (
              <Recipe
                key={product.productId}
                cartProduct={product}
                hasFavoritesEnabled={hasFavoritesEnabled}
              />
            ))}
          </div>
          <ProductPackage
            menuHeader={menu.product_package_header}
            menuSubHeader={menu.product_package_sub_header}
          />
          <div className="row">
            {itemsAfterIndex.map((product) => (
              <Recipe
                key={product.productId}
                cartProduct={product}
                hasFavoritesEnabled={hasFavoritesEnabled}
              />
            ))}
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="c-form-group c-recipe-gallery">
        <div className="row">
          {productsByMealType.map((product) => (
            <Recipe
              key={product.productId}
              cartProduct={product}
              hasFavoritesEnabled={hasFavoritesEnabled}
            />
          ))}
        </div>
        { mealTypeIndex === 0 && hasCpppEnabled && !lastAddedItem && (
        <ProductPackage
          menuHeader={menu.product_package_header}
          menuSubHeader={menu.product_package_sub_header}
        />
        )}
      </div>
    </>
  );
}

export default MealTypeRecipes;
